import React from 'react'
import { Edit, required, SelectInput, SimpleForm, TextInput, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { HasPermission } from 'src/helper/HasPermission'

export const ReservationEdit = (props) => {
  const translate = useTranslate()

  return (
    <Edit title='Reservation' {...props} actions={null}>
      <CardCommon title={translate('ra.title.update_reservation')} actions={null}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <HasPermission permission={'status'} resource={'reservation'}>
              <EditInputsWrap label={translate('ra.field.status')}>
                <SelectInput
                  source='status'
                  optionText='text'
                  fullWidth
                  choices={[
                    { id: 'OPEN', text: translate('ra.status.OPEN') },,
                    { id: 'FINALIZED', text: translate('ra.status.FINALIZED') },
                    { id: 'CLOSED', text: translate('ra.status.CLOSED') },
                    { id: 'CANCELLED', text: translate('ra.status.CANCELLED') },
                    { id: 'DELETED', text: translate('ra.status.DELETED'), disabled: true }
                  ]}
                  label=''
                  validate={required()}
                />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.concept')}>
                <TextInput source='concept' label={false} fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.date_in')}>
                <TextInput source='date_in' label={false} fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.date_out')}>
                <TextInput source='date_out' label={false} fullWidth />
              </EditInputsWrap>
            </HasPermission>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
